import React from 'react';
import { Box, HStack, MenuButton, Text, useMenuContext, } from '@chakra-ui/react';
import { localise } from '../../../services/lang/lang';
import Chevron, { ChevronDirection } from '../../icons/Chevron';
import MultiSelect from '../MultiSelect/MultiSelect';
const getText = (selectedValues, selectionGroups, hasOneAlwaysSelected) => {
    if (!selectedValues?.length) {
        return localise('ALL');
    }
    if (selectedValues.length > 1) {
        return localise('MULTIPLE');
    }
    if (hasOneAlwaysSelected)
        return localise('ALL');
    const selectedItem = selectionGroups
        .flatMap((group) => group.items)
        .find((item) => item.value === selectedValues[0]);
    if (!selectedItem) {
        throw new Error('Unknown selected option provide');
    }
    return selectedItem.title;
};
const MultiFilter = (props) => {
    const { onClose } = useMenuContext();
    const text = getText(props.selectedValues, props.selectionGroups, props.hasOneAlwaysSelected);
    return (React.createElement(Box, { "data-testid": "multi_filter" },
        React.createElement(MenuButton, { "dats-testid": "multi_filter__button" },
            React.createElement(HStack, { justify: "space-between" },
                React.createElement(Text, { "data-testid": "multi_filter__text" }, text),
                React.createElement(Chevron, { direction: ChevronDirection.DOWN }))),
        React.createElement(MultiSelect, { filterLabel: localise('APPLY_FILTER'), groups: props.selectionGroups, onApply: (values) => {
                onClose();
                props.onApply(values);
            } })));
};
export default MultiFilter;
